import React from "react";
import * as styles from "./autocomplete.scss";
import { searchPageUrl } from "Shared/known-urls";
import { urlToString } from "Shared/url";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
class DidYouMean extends React.PureComponent {
    render() {
        const items = !!this.props.quickSearch.completionsLists.filter((x) => x.id === "suggestions")[0] &&
            !!this.props.quickSearch.completionsLists.filter((x) => x.id === "suggestions")[0].searchDidYouMean &&
            this.props.quickSearch.completionsLists.filter((x) => x.id === "suggestions")[0].searchDidYouMean;
        return (!!items &&
            items.length > 0 && (React.createElement("ul", { key: "DidYouMean" },
            React.createElement("li", null, `${translate("/Shared/FadeNoHits")} ${translate("/Shared/FadeDidYouMean")}`),
            items.map((item, j) => {
                return (React.createElement("li", { key: item.text + j },
                    React.createElement("a", { href: urlToString({
                            path: searchPageUrl().url,
                            query: { q: item.text },
                        }), "data-ticket": item.ticket, className: styles.button, onClick: () => !!this.props.onItemClick &&
                            this.props.onItemClick(item.text) }, item.text)));
            }))));
    }
}
export default connect((state) => ({
    quickSearch: state.quickSearch,
}))(DidYouMean);
